import actions from './actions';
import getters from './getters';
import mutations from './mutations';
export var state = function state() {
  return {
    abtestToggleState: false,
    abtestToggleTooltypeState: false
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};